// Mock data for Noah Lammers Mobile Detailing

export const businessInfo = {
  name: "Mobile Shine",
  tagline: "Premium Mobile Detailing",
  phone: "236-335-7663",
  email: "Noah.lammers5@gmail.com",
  address: "Willoughby, Langley, BC",
  serviceArea: "Free service within 20 km radius • Extended coverage available"
};

// Pricing constants
export const TRAVEL_FEE = 0; // Free within service radius

// Travel Fee Structure
export const TRAVEL_FEE_INFO = {
  freeRadius: 20, // km from Willoughby, Langley BC (84 Ave & 208 St)
  freeZones: [
    "Langley",
    "Surrey",
    "White Rock",
    "Aldergrove",
    "Walnut Grove",
    "Cloverdale",
    "Delta"
  ],
  extendedZones: [
    { name: "Abbotsford", fee: 25 },
    { name: "Maple Ridge", fee: 25 },
    { name: "Pitt Meadows", fee: 30 },
    { name: "Coquitlam", fee: 30 },
    { name: "Mission", fee: 35 },
    { name: "Burnaby", fee: 35 },
    { name: "Vancouver", fee: 40 },
    { name: "Chilliwack", fee: 50 }
  ],
  description: "Free travel within 20 km radius of Willoughby, Langley BC (84 Ave & 208 St area). Distance surcharge applies for extended service areas."
};

export const services = [
  {
    id: 1,
    title: "Standard Exterior",
    description: "Basic exterior wash and shine",
    features: ["Foam Wash", "Wheel Cleaning", "Tire Shine", "Window Cleaning (Interior + Exterior)"],
    pricing: {
      "Sedan": 79,
      "SUV": 95,
      "Truck": 103,
      "Van": 103
    },
    image: "https://images.pexels.com/photos/29504462/pexels-photo-29504462.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    duration: "45-60 mins"
  },
  {
    id: 2,
    title: "Deluxe Exterior",
    description: "Premium exterior wash with quick protection",
    features: ["Foam Wash", "Wheel Cleaning", "Wheel Well Cleaning", "Tire Shine", "Window Cleaning (Interior + Exterior)", "Spray Wax Protection"],
    pricing: {
      "Sedan": 111,
      "SUV": 127,
      "Truck": 143,
      "Van": 143
    },
    image: "https://images.pexels.com/photos/29922284/pexels-photo-29922284.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    duration: "1.5-2 hours"
  },
  {
    id: 2.5,
    title: "Premium Exterior",
    description: "Elite exterior service with traditional hand wax - SAVE $20-$30 when you bundle!",
    features: ["Everything in Deluxe Exterior", "Traditional Hand Wax Application", "Deep Gloss Enhancement", "Long-Lasting Paint Protection", "Meticulous Hand Application", "Premium Bundle Savings"],
    pricing: {
      "Sedan": 165,
      "SUV": 185,
      "Truck": 205,
      "Van": 205
    },
    image: "https://images.pexels.com/photos/29922284/pexels-photo-29922284.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    duration: "2.5-3 hours",
    badge: "PREMIUM"
  },
  {
    id: 3,
    title: "Standard Interior Service",
    description: "Deep interior cleaning and sanitization",
    features: ["Full Vacuum (Seats, Carpets, Trunk)", "Deep Clean & Sanitize", "Plastic & Vinyl Protection", "Interior Glass Cleaning", "Air Vents", "Console Detail"],
    pricing: {
      "Sedan": 119,
      "SUV": 135,
      "Truck": 143,
      "Van": 143
    },
    image: "https://images.unsplash.com/photo-1771491237209-b89bc7290588?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxpbnRlcmlvciUyMGRldGFpbGluZ3xlbnwwfHx8fDE3NzY0OTI4NzV8MA&ixlib=rb-4.1.0&q=85",
    duration: "1.5-2 hours"
  },
  {
    id: 4,
    title: "Complete Detail - Standard",
    description: "Full interior and exterior - SAVE $49-$59 when you bundle! (20% OFF)",
    features: ["Foam Wash", "Wheel Cleaning", "Tire Shine", "Window Cleaning (Interior + Exterior)", "Interior Deep Clean & Vacuum", "Sanitization", "20% Bundle Savings", "Most Requested Package"],
    pricing: {
      "Sedan": 159,
      "SUV": 183,
      "Truck": 199,
      "Van": 199
    },
    image: "https://images.pexels.com/photos/29922284/pexels-photo-29922284.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    duration: "2.5-3 hours",
    badge: "MOST POPULAR"
  },
  {
    id: 5,
    title: "Complete Detail - Deluxe",
    description: "Premium full detail with paint protection - SAVE $19-$39 when you bundle!",
    features: ["Everything in Standard Complete", "Spray Wax Protection", "Wheel Well Cleaning", "Plastic & Vinyl Protection", "Premium Bundle Savings", "Ultimate Protection Package"],
    pricing: {
      "Sedan": 179,
      "SUV": 203,
      "Truck": 224,
      "Van": 224
    },
    image: "https://images.pexels.com/photos/29922284/pexels-photo-29922284.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    duration: "3-4 hours",
    badge: "BEST VALUE"
  },
  {
    id: 5.5,
    title: "Complete Detail - Premium",
    description: "Ultimate full detail with traditional hand wax - SAVE $40-$75 when you bundle! Our highest-end complete package.",
    features: ["Everything in Deluxe Complete", "Traditional Hand Wax Application", "Deep Gloss Enhancement", "Maximum Paint Protection", "Meticulous Hand Application", "Superior Bundle Savings", "Highest-End Complete Package"],
    pricing: {
      "Sedan": 229,
      "SUV": 259,
      "Truck": 289,
      "Van": 289
    },
    image: "https://images.pexels.com/photos/29922284/pexels-photo-29922284.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    duration: "3.5-4.5 hours",
    badge: "PREMIUM"
  },
  {
    id: 6,
    title: "Essential Ceramic Shield",
    description: "High-performance slickness and chemical protection for leased vehicles or budget-conscious owners - COMING SOON",
    features: [
      "12-24 Month Durability (CARPRO CQUARTZ Lite)",
      "Full Chemical & Clay Bar Decontamination",
      "Gloss Enhancement Machine Polish",
      "Hydrophobic Paint Surface Coating",
      "Entry-Level Protection",
      "Best for Leased Vehicles"
    ],
    pricing: {
      "Sedan": 650,
      "SUV": 750,
      "Truck": 850,
      "Van": 850
    },
    image: "https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw2fHxjYXIlMjBzaGluZXxlbnwwfHx8fDE3MzY5NTc0OTF8MA&ixlib=rb-4.1.0&q=85",
    duration: "3-4 hours",
    badge: "COMING SOON",
    unavailable: true
  },
  {
    id: 7,
    title: "Everyday Diamond Gloss",
    description: "Our most popular ceramic package. Erases common wash scratches and locks in a rich, glass-like shine - COMING SOON",
    features: [
      "3 Year Durability (CARPRO CQUARTZ UK 3.0)",
      "1-Stage Paint Correction (50-70% Defect Removal)",
      "Full Chemical & Clay Bar Decontamination",
      "Hydrophobic Paint Coating",
      "Exterior Plastic Trim Coating",
      "Most Popular Choice"
    ],
    pricing: {
      "Sedan": 1000,
      "SUV": 1250,
      "Truck": 1450,
      "Van": 1450
    },
    image: "https://images.unsplash.com/photo-1601362840469-51e4d8d58785?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxjYXIlMjBnbG9zc3xlbnwwfHx8fDE3MzY5NTc0NzZ8MA&ixlib=rb-4.1.0&q=85",
    duration: "4-6 hours",
    badge: "COMING SOON",
    unavailable: true
  },
  {
    id: 8,
    title: "Showroom Platinum Protection",
    description: "The ultimate multi-year shield using CARPRO CQUARTZ UK 3.0, restoring deep clarity and maximizing resale value - COMING SOON",
    features: [
      "3-5 Year Durability (CARPRO CQUARTZ UK 3.0)",
      "2-Stage Paint Correction (85%+ Defect Removal)",
      "Full Chemical & Clay Bar Decontamination",
      "Deep Gloss Paint Coating",
      "Windshield Glass Coating",
      "Exterior Plastic Trim Restoration & Coating",
      "Wheel Face Coating"
    ],
    pricing: {
      "Sedan": 1500,
      "SUV": 1800,
      "Truck": 2100,
      "Van": 2100
    },
    image: "https://images.unsplash.com/photo-1520340356584-f9917d1eea6f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxjZXJhbWljJTIwY29hdGluZ3xlbnwwfHx8fDE3MzY5NTc0NjB8MA&ixlib=rb-4.1.0&q=85",
    duration: "6-8 hours",
    badge: "COMING SOON",
    unavailable: true
  }
];

// Service Add-ons
export const serviceAddons = [
  {
    id: 1,
    title: "Basic Wheel Cleaning (Wheels-On)",
    description: "Professional caliper and wheel cleaning without wheel removal. Specialized long-reach brushes and iron-decontamination chemical sprays to clean calipers through existing rim spokes.",
    pricing: {
      "Sedan": 49,
      "SUV": 49,
      "Truck": 49,
      "Van": 49
    },
    duration: "30-45 min",
    notes: "Best for regular maintenance. Open-spoke rims clean faster. Multi-spoke mesh wheels require more precision."
  },
  {
    id: 2,
    title: "Deep Wheel Clean & Ceramic Coating (Wheels-Off)",
    description: "Premium wheels-off service with complete wheel removal for unhindered access. Includes heavy decontamination, 100% caliper scrubbing, inner barrel deep clean, and high-temperature ceramic wheel and caliper coating to repel future brake dust. - COMING SOON",
    pricing: {
      "Sedan": 374,
      "SUV": 374,
      "Truck": 374,
      "Van": 374
    },
    duration: "2-3 hours",
    notes: "Vehicle safely jacked up, all four wheels removed. Premium ceramic protection included. Best for show cars or severely neglected wheels.",
    unavailable: true
  },
  {
    id: 3,
    title: "Shampooing Extraction",
    description: "Deep shampooing and extraction for cloth seats, carpets, and floor mats",
    pricing: {
      "Sedan": 124,
      "SUV": 149,
      "Truck": 174,
      "Van": 174
    },
    duration: "60-90 min"
  },
  {
    id: 4,
    title: "Pet Hair Removal",
    description: "Thorough removal of pet hair from all interior surfaces",
    pricing: {
      "Sedan": 65,
      "SUV": 65,
      "Truck": 65,
      "Van": 65
    },
    duration: "30-45 min"
  },
  {
    id: 5,
    title: "Hand Wax",
    description: "Premium hand-applied wax for long-lasting shine and protection",
    pricing: {
      "Sedan": 89,
      "SUV": 124,
      "Truck": 124,
      "Van": 149
    },
    duration: "45-60 min"
  },
  {
    id: 6,
    title: "Door Jamb Cleaning",
    description: "Detailed cleaning of door jambs and edges for a complete finish",
    pricing: {
      "Sedan": 39,
      "SUV": 39,
      "Truck": 39,
      "Van": 39
    },
    duration: "15-20 min"
  },
  {
    id: 7,
    title: "Odor Elimination",
    description: "Specialized treatment to remove odors and bio-hazards from your vehicle",
    pricing: {
      "Sedan": 124,
      "SUV": 149,
      "Truck": 174,
      "Van": 174
    },
    duration: "45-60 min"
  },
  {
    id: 8,
    title: "Headlight Restoration",
    description: "Premium mobile wet-sanding and ceramic coating restoration. Multi-stage sanding (600→3000 grit), professional polishing, and UV-protective ceramic clear coat application for long-lasting clarity.",
    pricing: {
      "Sedan": 149,
      "SUV": 149,
      "Truck": 149,
      "Van": 149
    },
    duration: "50-70 min",
    notes: "Includes prep/masking, wet-sanding through 5+ grits, dual-action polishing, and ceramic coating. Price varies based on oxidation severity."
  },
  {
    id: 10,
    title: "Paint Decontamination (Clay Bar)",
    description: "Professional clay bar treatment to remove bonded contaminants, industrial fallout, and embedded particles from paint surface for a smooth, clean finish",
    pricing: {
      "Sedan": 49,
      "SUV": 59,
      "Truck": 69,
      "Van": 69
    },
    duration: "30-45 min",
    notes: "Recommended before waxing or ceramic coating. Removes contaminants that washing alone cannot."
  },
  {
    id: 11,
    title: "Leather Conditioning",
    description: "Professional leather conditioning treatment to restore, protect, and maintain leather seats and interior surfaces",
    pricing: {
      "Sedan": 45,
      "SUV": 45,
      "Truck": 45,
      "Van": 45
    },
    duration: "20-30 min",
    notes: "Prevents cracking and fading. Restores natural oils to leather surfaces. Recommended every 3-6 months."
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_mobile-detail-site/artifacts/ju230rq4_IMG_5522.webp",
    title: "Exterior Detail - Before (Dusty Hood & Grille)",
    category: "exterior",
    type: "before"
  },
  {
    id: 2,
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_mobile-detail-site/artifacts/scffa4qj_IMG_5525.webp",
    title: "Exterior Detail - Before (Front View)",
    category: "exterior",
    type: "before"
  },
  {
    id: 3,
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_mobile-detail-site/artifacts/d0249m6k_IMG_5526.webp",
    title: "Exterior Detail - Before (Top View)",
    category: "exterior",
    type: "before"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1605697379493-5af3ec4d3daa",
    title: "Premium Exterior Detail",
    category: "exterior"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1549064233-945d7063292f",
    title: "Luxury Interior Clean",
    category: "interior"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1617498115469-2a7ee098a575",
    title: "Showroom Gloss Finish",
    category: "exterior"
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1625690180114-5530b1304127",
    title: "Premium Interior Detailing",
    category: "interior"
  },
  {
    id: 8,
    url: "https://images.pexels.com/photos/29580174/pexels-photo-29580174.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Performance Car Detail",
    category: "exterior"
  },
  {
    id: 9,
    url: "https://images.pexels.com/photos/7662147/pexels-photo-7662147.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Luxury Sports Car",
    category: "exterior"
  }
];

export const timeSlots = [
  "8:00 AM", "9:00 AM", "10:00 AM", "11:00 AM",
  "12:00 PM", "1:00 PM", "2:00 PM", "3:00 PM", "4:00 PM", "5:00 PM"
];

export const vehicleTypes = [
  "Sedan",
  "SUV",
  "Truck",
  "Van"
];

// Mock booking submissions
export const mockBookingSubmit = (bookingData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        bookingId: `BOOKING-${Date.now()}`,
        message: "Booking request received! We'll confirm shortly."
      });
    }, 1000);
  });
};

// Mock contact form submissions
export const mockContactSubmit = (contactData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        message: "Message sent! We'll get back to you soon."
      });
    }, 1000);
  });
};

// Customer reviews
export const reviews = [
  {
    id: 1,
    name: "Michael Stevens",
    rating: 5,
    date: "2 weeks ago",
    service: "Complete Service",
    review: "Outstanding work! My SUV looks brand new. The team was professional, punctual, and paid attention to every detail. Best detailing service I've ever used.",
    vehicle: "SUV"
  },
  {
    id: 2,
    name: "Sarah Johnson",
    rating: 5,
    date: "1 month ago",
    service: "Interior Service",
    review: "Incredible interior cleaning! They got stains out that I thought were permanent. My car smells fresh and looks immaculate. Highly recommend!",
    vehicle: "Sedan"
  },
  {
    id: 3,
    name: "David Martinez",
    rating: 5,
    date: "3 weeks ago",
    service: "Exterior Service",
    review: "My truck's paint has never looked this good. Great value for the price, and they came right to my workplace. Very convenient!",
    vehicle: "Truck"
  },
  {
    id: 4,
    name: "Jennifer Lee",
    rating: 5,
    date: "2 months ago",
    service: "Complete Service",
    review: "Mobile Shine transformed my family van inside and out. With three kids, it was a mess! Now it's spotless. They're my go-to detailers now.",
    vehicle: "Van"
  },
  {
    id: 5,
    name: "Robert Chen",
    rating: 5,
    date: "1 week ago",
    service: "Exterior Service",
    review: "Professional service from start to finish. Booking was easy, they showed up on time, and the results exceeded my expectations. Will definitely use again!",
    vehicle: "Sedan"
  },
  {
    id: 6,
    name: "Amanda Foster",
    rating: 5,
    date: "3 weeks ago",
    service: "Interior Service",
    review: "The attention to detail is amazing. Every surface was cleaned and conditioned perfectly. My SUV's interior looks showroom quality. Worth every penny!",
    vehicle: "SUV"
  }
];
